import type { SideNavMenuItemProps } from 'components/Navigation/SideNav';

export const hasSideNavItem = (
  items: SideNavMenuItemProps[],
  key: string,
): boolean =>
  items.some(
    item =>
      String(item.key) === key ||
      (!!item.secondary && hasSideNavItem(item.secondary, key)),
  );
